import getConfig from 'next/config';

const {publicRuntimeConfig: config} = getConfig();

const feeds = {
    category: ({tenantId, categoryId}) => `${config.feedDomain}/${tenantId}/category/${categoryId}`,
    categoryPreview: ({tenantId, categoryId, previewKey}) => `${config.feedDomain}/${tenantId}/preview_category/${categoryId}?previewkey=${previewKey}`,
    categoryPreviewTimestamp: ({tenantId, categoryId, previewKey}) =>
        `${config.feedDomain}/${tenantId}/preview_category/${categoryId}/timestamp?previewkey=${previewKey}`,
    content: ({tenantId, metadataId}) => `${config.feedDomain}/${tenantId}/content/${metadataId}`,
    preview: ({tenantId, metadataId, previewKey}) => `${config.feedDomain}/${tenantId}/preview_content/${metadataId}?key=${previewKey}`,
    legacy: ({tenantId, legacyId}) => `${config.feedDomain}/${tenantId}/legacy/${legacyId}`,
    sitemap: ({tenantId}) => `${config.feedDomain}/${tenantId}/sitemap`
};

const getFeedUrl = (feedType, param) => feeds[feedType]({tenantId: config.tenantId, ...param});

export {getFeedUrl};
